module.exports = __webpack_public_path__ + "img/Scorecards-Teaser.223d2e47.jpg";